import { useSelector } from 'react-redux';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    CriteriaMutationResourceSchema,
    CriteriaPropertyValidation,
    defaultCriteriaResource,
    useCriteriaActions,
} from '../../../../../resource/resources/artifacts/criteria/criteriaResource';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { SingleParentedOverviewComponent } from '../../../../reusable-components/resource-overviews/SingleParentedOverviewComponent';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { CriteriaContent } from './CriteriaContent';

const CriteriaOverviewContent = ({ id, displayedInOverview }: { id: string; displayedInOverview: boolean }) => {
    const readOnly = useSelector(selectReadOnly);

    const criteriaActions = useCriteriaActions();
    const criteriaQuery = criteriaActions.useGetResource(id);
    const updateCriteria = criteriaActions.useUpdateResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: CriteriaMutationResourceSchema,
        defaultValues: defaultCriteriaResource,
        submitHandler: async (data) => {
            await updateCriteria.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: criteriaQuery.data,
    });

    return (
        <QueryBaseComponent name="Criteria" query={criteriaQuery}>
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                <CriteriaContent
                    displayedInOverview={displayedInOverview}
                    form={form}
                    formNames={formNames}
                    readOnly={readOnly}
                    id={id}
                />
            </Form_DisplayComponentBaseView>
        </QueryBaseComponent>
    );
};

export const CriteriaOverviewComponent = ({ parentId }: { parentId: string }) => {
    const validationScope = useSelector(selectNoScopeValidationScope);

    const criteriaActions = useCriteriaActions();

    const parametersQuery = criteriaActions.useGetAllResources(parentId);

    const resourceType = ResourceType.CRITERIA;

    return (
        <QueryBaseComponent name="Criterias" query={parametersQuery}>
            <SingleParentedOverviewComponent
                label={'Criterias'}
                resourceQuery={parametersQuery}
                content={(id, displayedInOverview) => (
                    <CriteriaOverviewContent id={id} displayedInOverview={displayedInOverview} />
                )}
                propertyValidationInformation={{
                    namePropertyIdentifier: CriteriaPropertyValidation.NAME,
                    resourceType,
                }}
                validationScope={validationScope}
                parentId={parentId}
            />
        </QueryBaseComponent>
    );
};
